import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { Cancel } from "@mui/icons-material";
import LoadingView from "../../components/LoadingView/LoadingView.js";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal.js";

function AddLoyaltyDialog(props) {
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);

  const { dialogType, selectedRestaurant } = props;

  // Form state - Toggles
  const [isEnabled, setIsEnabled] = useState(true);
  const [isCountIncreaseByOrder, setIsCountIncreaseByOrder] = useState(true);
  
  // Form state - Inputs
  const [orderAmount, setOrderAmount] = useState("");
  const [reward, setReward] = useState("");

  const apiAddress = process.env.REACT_APP_SECRET;

  const handleClose = () => {
    props.onHandleAddItem(false);
    // Reset form
    setIsEnabled(true);
    setIsCountIncreaseByOrder(true);
    setOrderAmount("");
    setReward("");
  };

  const submit = async () => {
    var valid = true;

    // Validation
    if (!selectedRestaurant || !selectedRestaurant.id) {
      valid = false;
      toast.error("Restaurant not selected", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }

    if (orderAmount === "" || orderAmount === undefined || orderAmount === null) {
      valid = false;
      toast.error("Order amount is required", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }

    if (reward === "" || reward === undefined || reward === null) {
      valid = false;
      toast.error("Reward is required", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    }

    if (valid) {
      const rewardData = {
        restaurantId: selectedRestaurant.id,
        isEnabled: isEnabled,
        isCountIncreaseByOrder: isCountIncreaseByOrder,
        orderAmount: parseInt(orderAmount),
        reward: reward,
      };

      setLoadingModal(true);
      setIsSubmitting(true);

      axios({
        method: "post",
        url: apiAddress + "/api/SubSection/AddLoyaltyScheme",
        data: rewardData,
      })
        .then((response) => {
          // Reset form
          setIsEnabled(true);
          setIsCountIncreaseByOrder(true);
          setOrderAmount("");
          setReward("");

          setOpenConfirmationModal(false);
          props.onHandleAddItem(false);
          setIsSubmitting(false);
          setLoadingModal(false);

          toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        })
        .catch((error) => {
          setLoadingModal(false);
          setIsSubmitting(false);
          toast.error("Failed to save loyalty scheme", {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        });
    }
  };

  const closeLoadingModal = () => {
    setLoadingModal(false);
  };

  return (
    <div>
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />

          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to save this loyalty scheme?"}
            open={openConfirmationModal}
            onyes={submit}
            close={() => {
              setOpenConfirmationModal(false);
            }}
            disableYesButton={isSubmitting}
          />
          <ToastContainer />
          
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType || "Add Loyalty Scheme"}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <Cancel style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>

          <DialogContent>
            <Box sx={{ padding: "0.5rem" }}>
              {/* Restaurant Info (Read-only display) */}
              <Grid container sx={{ padding: "0.5rem", marginBottom: "1rem" }}>
                <Grid item xs={12}>
                  <Typography variant="body2" color="textSecondary">
                    Restaurant: <strong>{selectedRestaurant?.name || "Not Selected"}</strong>
                  </Typography>
                </Grid>
              </Grid>

              {/* Toggle Switches Section - উপরে */}
              <Box sx={{ 
                backgroundColor: "#f5f5f5", 
                padding: "1rem", 
                borderRadius: "8px",
                marginBottom: "1.5rem"
              }}>
                <Typography variant="h6" sx={{ marginBottom: "1rem", fontSize: "16px" }}>
                  Settings
                </Typography>

                {/* Is Enabled Switch */}
                <Grid container sx={{ padding: "0.5rem", alignItems: "center" }}>
                  <Grid item xs={6}>
                    <Typography>Enable Loyalty Scheme</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: "right" }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isEnabled}
                          onChange={(e) => setIsEnabled(e.target.checked)}
                          color="primary"
                        />
                      }
                      label={isEnabled ? "Enabled" : "Disabled"}
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>

                {/* Is Count Increase By Order Switch */}
                <Grid container sx={{ padding: "0.5rem", alignItems: "center" }}>
                  <Grid item xs={6}>
                    <Typography>Count Increase By Order</Typography>
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: "right" }}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isCountIncreaseByOrder}
                          onChange={(e) =>
                            setIsCountIncreaseByOrder(e.target.checked)
                          }
                          color="primary"
                        />
                      }
                      label={isCountIncreaseByOrder ? "Yes" : "No"}
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Input Fields Section - নিচে */}
              <Box>
                <Typography variant="h6" sx={{ marginBottom: "1rem", fontSize: "16px" }}>
                  Loyalty Details
                </Typography>

                {/* Order Amount */}
                <Grid container sx={{ padding: "0.5rem", marginBottom: "1rem" }}>
                  <Grid item xs={12}>
                    <Typography sx={{ marginBottom: "0.5rem" }}>
                      Order Amount <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      id="order-amount"
                      value={orderAmount}
                      placeholder="Enter minimum order amount"
                      variant="outlined"
                      fullWidth
                      type="number"
                      onChange={(event) => {
                        setOrderAmount(event.target.value);
                      }}
                      helperText="Minimum order amount required for reward"
                    />
                  </Grid>
                </Grid>

                {/* Reward */}
                <Grid container sx={{ padding: "0.5rem", marginBottom: "1rem" }}>
                  <Grid item xs={12}>
                    <Typography sx={{ marginBottom: "0.5rem" }}>
                      Reward <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      id="reward"
                      value={reward}
                      placeholder="Enter reward (e.g., Free Chicken, 10% Discount)"
                      variant="outlined"
                      fullWidth
                      onChange={(event) => {
                        setReward(event.target.value);
                      }}
                      helperText="What customer will receive as reward"
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Save Button */}
              <Grid container sx={{ padding: "0.5rem", marginTop: "1rem" }}>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => setOpenConfirmationModal(true)}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save Loyalty Scheme"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default AddLoyaltyDialog;